import React from 'react';
import background from '../../assets/vote.jpg';
import ReusableAskearth from '../../components/ReusableAskearth/ReusableAskearth';

class PromptVerifyregistration extends React.Component {
  render () { 
   return(
  
  <ReusableAskearth             
    
        tag="TAKE ACTION"
        description01="Am I registered to vote?"

        
        background={background}
     />
  
  );
 }
}   

export default PromptVerifyregistration;